import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import DecoyLanding from './pages/DecoyLanding'
import AccessRequest from './pages/AccessRequest'
import Register from './pages/Register'
import Login from './pages/Login'
import NDAPage from './pages/NDAPage'
import Portal from './pages/Portal'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<DecoyLanding />} />
          <Route path="/access" element={<AccessRequest />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/nda" element={<NDAPage />} />
          <Route path="/portal/*" element={
            <ProtectedRoute>
              <Portal />
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
